import React from 'react';
import { useAppSelector } from '../../data/store';
import { checkIsSubscription } from '../../domain/shopping-cart-provider';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';
import { ICartItem } from '../../interfaces';

export const ONLINE_MASTERING_PRO_ANNUAL_SKUNUMBER = 'SUBSOLMUNCA';

export const getPeriodText = (period: string|undefined) => {
    if(!period) return '';

    switch(period) {
        case 'annual': {
            return 'year';
        }
        case 'monthly': {
            return 'month';
        }
        case 'weekly': {
            return 'week';
        }
        case 'daily': {
            return 'day';
        }
    }

    return '';
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-2667
 */
const ConfirmText = () => {

    const cartData = useAppSelector(store => store.root.cartData);

    const isSubscription = checkIsSubscription(cartData);
    // const isSampleMakerSubscription = checkIsSampleMakerSubscriptions(cartData);
    // const isVoiceRegenNotFreeSubscriptionPurchase = checkIsVoiceRegenNotFreeSubscription(cartData);
    // const isMasteringSubscription = checkIsMasteringSubscription(cartData);


    let subscription: ICartItem| null|undefined = null;
    let text = '';

    if(isSubscription){
        subscription = cartData.cartItems.find(cartItem => cartItem.isActive) ?? null;

        const hasTax = cartData.priceData.collectTax;
        const hasCoupons = cartData.redeemedCoupons.length > 0;
        const numberOfFreeDays = Number(subscription?.numberOfFreeDays) || 0;
        const hasFreeTrial = numberOfFreeDays > 0;

        // monthly or yearly - (SP returns monthly or annual in field SBSPeriod)
        let period = (subscription?.sbsPeriod ?? 'monthly');
        if(period === 'annual'){
            period = 'annually';
        }
        period = ` ${ period }`

        if(!hasFreeTrial && !hasCoupons && !hasTax){
            // no free trial, no coupon, no tax
            text = `${period}. `;
        }

        if(!hasFreeTrial && !hasCoupons && hasTax){
            // no free trial, no coupon, tax
            text = `${ period }, not including taxes. `;
        }

        if(!hasFreeTrial && hasCoupons && !hasTax){
            // no free trial, coupon, no tax
            text = `${ period } not including the discounts above. `
        }

        if(!hasFreeTrial && hasCoupons && hasTax){
            // no free trial, coupon, tax
            text = `${ period } not including the discounts above and taxes. `;
        }

        // -----------------

        if(hasFreeTrial && !hasCoupons && !hasTax){
            // free trial, no coupon, no tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial. `;
        }

        if(hasFreeTrial && !hasCoupons && hasTax){
            // free trial, no coupon, tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial, not including taxes. `;
        }

        if(hasFreeTrial && hasCoupons && !hasTax){
            // free trial, coupon, no tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial, not including the discounts above. `
        }

        if(hasFreeTrial && hasCoupons && hasTax){
            // free trial, coupon, tax
            text = `${ period } after a free ${ numberOfFreeDays }-day trial, not including the discounts above and taxes. `;
        }
    }

    const getSubscriptionTerms = () => {
       /* if(isSampleMakerSubscription) {
            return (
                <>
                    You acknowledge that you have read and agree to the <a href="/legal/eula">End User License Agreement</a>, and <a href="/legal/illugen-service-agreement">ILLUGEN Master Service Agreement</a>.
                </>
            )
        }*/

       /* if(isVoiceRegenNotFreeSubscriptionPurchase) {
            return (
                <> You acknowledge that you have read and agree to the <a href="/legal/eula">End User License Agreement</a>, and <a href="/legal/voice-regen-service-agreement">Voice ReGen Master Service Agreement</a>.</>
            );
        }*/

        if(subscription?.skuNumber === ONLINE_MASTERING_PRO_ANNUAL_SKUNUMBER) {
            return (
                <> You acknowledge that you have read and agree to the <a href="/legal/waves-terms-of-use">Waves Terms of Use</a>, and <a href="/legal/online-mastering-fair-usage-policy">Online Mastering Fair Usage Policy</a>.</>
            );
        }

        /*if(isMasteringSubscription && subscription?.skuNumber !== ONLINE_MASTERING_PRO_ANNUAL_SKUNUMBER) {
            return (
                <> You acknowledge that you have read and agree to the <a href="/legal/eula">End User License Agreement</a>.</>
            )
        }*/

        return <> You acknowledge that you have read and agree to the <a href="/legal/waves-terms-of-use">Waves Terms of Use</a>.</>;
    };

    return (
        <div className="text-gray-700 mb-4 mt-10 text-sm">
            <p>
                {
                    !isSubscription &&
                    <span>All sales are final, all prices are in US dollars.</span>
                }

                {
                    isSubscription && subscription && (
                        <>
                            All prices are in US dollars.
                            You will be charged <ProductPriceFormat price={ subscription.skU_MSRP } /> { text }
                            Your subscription will automatically renew each { getPeriodText(subscription?.sbsPeriod) } until you cancel.
                            You can cancel your subscription in your Waves account.

                            { getSubscriptionTerms() }
                        </>
                    )
                }
            </p>
        </div>
    )
};

export default ConfirmText;